<template>
  <div>
    <tab-bar currentActive="settings" @changeActive="changeTabbar"></tab-bar>
    <div class="container-fluid">
      <div class="row mt-5">
        <div class="col">
          <div class="position-relative w-100">
            <div class="position-absolute" style="z-index: 2000; top: -30px; right: 10px">
              <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
                @click="$router.push('/settings').catch(err => { })" style="width: 30px; height: 30px; min-height: 0">
                <icon width="20" height="20" name="times"></icon>
              </div>
            </div>
          </div>
          <h1>TECH. OPÉRATOIRES</h1>
          <h2>NOS GUIDES</h2>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <h3>Hanche</h3>
          <div class="oneline d-flex" v-for="(item, index) in hancheslist" :key="index">
            <div class="flex-grow-1 mr-3" style="overflow-wrap: break-word; inline-size: min-content; overflow: hidden">
              {{ item.fi_file }}
            </div>
            <div class="text-right">
              <a :href="item.fi_file" target="_blank" class="btn btn-secondary btn-sm" @click="downloadDoc(item)">
                Télécharger </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <h3>Genou</h3>
          <div class="oneline d-flex" v-for="(item, index) in genouxlist" :key="index">
            <div class="flex-grow-1 mr-3" style="overflow-wrap: break-word; inline-size: min-content; overflow: hidden">
              {{ item.fi_file }}
            </div>
            <div class="text-right">
              <a :href="item.fi_file" target="_blank" class="btn btn-secondary btn-sm" @click="downloadDoc(item)">
                Télécharger </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";
import { version } from "../../package.json";

export default {
  name: "home-settings",
  components: {},
  data() {
    return {
      notdisplayanymore: false,
      version,
      hancheslist: [],
      genouxlist: []
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    // console.log("this.$route.path", this.$route.path);
    this.$store.dispatch("addHistoryUrl", this.$route.path);
    this.loadDocs();
    await this.$store.dispatch("setversion");
  },
  watch: {},
  computed: {},
  methods: {
    gotoPerso() {
      this.$router.push("/settings/perso").catch(err => {});
    },
    changeTabbar(where) {
      if (where == "patients") {
        this.showPassed = false;
      }
    },
    reloadApp() {
      window.location.reload();
    },

    downloadDoc(item) {
      window.open(
        this.$config.server_url + "/api/1.0/files/tech/download/" + item.fi_id + "?token=" + this.$store.state.accesstoken + "&origin=backoffice",
        "_blank"
      );
    },

    async loadDocs() {
      // let limit = 10000;
      let params = {
        // pa_archive: this.archive,
        // text: this.filterText,
        // sort: sort,
        // limit: limit,
        // pa_type: "hanche"
      };
      let response = await this.$axios.get(this.$config.server_url + "/api/1.0/files/tech/all", { params });
      // console.log("🚀 ~ loadDocs ~ response:", response.data.data);
      this.hancheslist = response.data.data.filter(p => {
        return p.fi_where == "hanche";
      });
      this.genouxlist = response.data.data.filter(p => {
        return p.fi_where == "genou";
      });
    }
  }
};
</script>

<style scoped lang="scss">
.m-form-checkbox {
  margin-bottom: 0;
}

.cguwin {
  position: fixed;
  background-color: white;
  border: 1px solid black;
  top: 5%;
  height: 90%;
  width: 90%;
  left: 5%;
  z-index: 10001;
  padding: 20px;

  // overflow: auto;
  .btn-jaccepte {
    position: absolute;
    bottom: 5px;
  }
}

.cguwin-content {
  overflow: auto;
}

@media (min-width: 576px) {
  .helpwin {}
}

@media (min-width: 768px) {
  .helpwin {}
}

.h-100vh {
  height: 100vh;
}

.bg-blue2 {
  background-color: rgb(161, 173, 194);
}

.topwhite {
  background-color: white;
  border-radius: 20px;
  padding: 20px;
}

.buttonsettings {
  width: 100%;
  text-align: left;
  background-color: rgb(237, 236, 236);
  border-radius: 10px;
  color: rgb(12, 40, 56);
  padding: 20px;
}

.oneline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
}
</style>
